import { syncingUpdated } from '../reducers/syncing/actionCreators';

export const createSyncingMiddleware =
  () =>
  ({ dispatch }) =>
  (next) =>
  (action) => {
    const { meta = {} } = action;
    if (meta.sync) {
      dispatch(syncingUpdated(meta.sync));
    }
    return next(action);
  };
